import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import type {
  ShippingRateCreateInput,
  ShippingRateUpdateInput,
} from "@/modules/shipping/domain/contracts";
import { isDevMode } from "@/shared/lib/config";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon, HelpCircleIcon } from "lucide-react";
import { useCreateRate, useZonesQuery } from "../api/queries";
import { RateFormTour, useRateFormTour } from "../tour";
import { RateForm } from "../ui/RateForm";

export function RateCreatePage() {
  const nav = useNavigate({ from: "/app/shipping/rates/new" });
  const zonesQuery = useZonesQuery();
  const zones = zonesQuery.data ?? [];
  const createRate = useCreateRate();
  const { run, handleJoyrideCallback, startTour } = useRateFormTour();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ອັດຕາຄ່າສົ່ງ", to: "/app/shipping/rates" },
            { label: "ສ້າງໃໝ່" },
          ]}
        />
      </Header>
      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງອັດຕາຄ່າສົ່ງ{" "}
              <Button
                variant="ghost"
                size="icon"
                onClick={startTour}
                className="ml-2 size-6"
                title="ເລີ່ມທົດລອງການນຳທາງ"
              >
                <HelpCircleIcon className="h-4 w-4" />
              </Button>
            </h2>
            <p className="text-muted-foreground">
              ເພີ່ມອັດຕາຄ່າສົ່ງ — ໂຊນ, ນ້ຳໜັກ (ກຣາມ), ຄ່າຂົນສົ່ງ.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/shipping/rates" } as any)}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>
        <div className="mt-6 rounded-xl border bg-card p-6">
          <RateForm
            zones={zones}
            onSubmit={async (
              values: ShippingRateCreateInput | ShippingRateUpdateInput,
            ) => {
              await createRate.mutateAsync(values as ShippingRateCreateInput);
              nav({ to: "/app/shipping/rates" } as any);
            }}
            onCancel={() => nav({ to: "/app/shipping/rates" } as any)}
            submitting={createRate.isPending}
            onDevFill={isDevMode ? () => {} : undefined}
          />
        </div>
        <RateFormTour run={run} onCallback={handleJoyrideCallback} />
      </Main>
    </>
  );
}
